import { InputLabel, styled } from "@mui/material";

export const DCFormLabel = styled(InputLabel)({
  fontSize: 14,
  lineHeight: 1.4,
  fontWeight: 400,
  marginBottom: "8px",
});
